import { FC, useMemo } from "react";
import { SubscriptionStatusWrapper } from "./styles";
import { FlexDiv } from "components/Layout/FlexDiv";
import { SubscriptionStatusProps } from "./types";
import moment from "moment";

const SubscriptionStatus: FC<SubscriptionStatusProps> = ({ subscription }) => {
  //Get expiration date and set the date of that as the current date in local time (no UTC)

  const currentExpDate = useMemo(() => {
    if (!subscription.expirationDate) {
      return null;
    }
    const date = new Date(subscription.expirationDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }, [subscription.expirationDate]);

  return (
    <SubscriptionStatusWrapper>
      <div className="controls-container">
        <FlexDiv className={`control red`}>
          {subscription.company.integrationType}
        </FlexDiv>
        <FlexDiv className={`control blue`}>
          {currentExpDate}
        </FlexDiv>
        <FlexDiv
          className={`control light-blue`}
          style={{
            textAlign: "center",
          }}
        >
          {!subscription.multiCustomer
            ? "Licenses : " + subscription.licenses
            : "Multicustomer"}
          <br />
          Active Users: {subscription.activeLicenses ?? 0}
          <br />
          Monitors: {subscription.activeMonitors ?? 0}
        </FlexDiv>
        <FlexDiv className={`control yellow`}>
          {subscription.lastLogin
            ? moment(subscription.lastLogin).format("DD/MM/YYYY")
            : "-"}
        </FlexDiv>
        <FlexDiv className={`control green`}>
          {subscription.subscriptionType}
        </FlexDiv>
        <FlexDiv
          className={`control light-blue`}
          style={{
            textAlign: "center",
          }}
        >
          {subscription.active ? "Active" : "Inactive"}
        </FlexDiv>
      </div>
    </SubscriptionStatusWrapper>
  );
};

export default SubscriptionStatus;
